import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[dpWidgetToggle]'
})
export class DpWidgetToggleDirective {
  constructor(public elementRef: ElementRef) {}
}
